import React from "react";
import {
  Calendar,
  CalendarProps,
  dayjsLocalizer,
  Event,
  HeaderProps,
} from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import dayjs from "dayjs";
import { Skeleton, Stack, Typography } from "@mui/joy";
import useStyleCalendarSchedule from "./utils/useStyleCalendarSchedule";
import useCalendarSchedule from "./utils/useCalendarSchedule";
import {
  TypeCalendarScheduleProps,
  TypeEventsCalendarSchedule,
} from "./utils/Types";
import {
  CustomEventItem,
  CustomHeader,
  CustomToolbar,
} from "./CustomComponent";
// import IconCustom from "@/components/elements/icon/IconCustom";

const localizer = dayjsLocalizer(dayjs);

const CalendarSchedule = (props: TypeCalendarScheduleProps) => {

  const { events, showDate, useTitle, slot, onClickEventItem } = props;
  const { view, setView, eventPropGetter } = useCalendarSchedule();
  const style = useStyleCalendarSchedule(props);

  return (
    <Stack sx={style.main}>
      {useTitle && (
        <Stack direction="row" sx={style.header}>
          <Typography sx={style.header.title} level={"h4"} component={"h1"}>
            {useTitle?.value || <Skeleton />}
          </Typography>
          {/* {useTitle?.onEdit && (
            <IconButton>
              <IconCustom name="edit" />
            </IconButton>
          )} */}
        </Stack>
      )}
      {slot?.action && <Stack sx={style.action}>{slot?.action}</Stack>}
      <Calendar
        style={style.calendar}
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        view={view}
        eventPropGetter={eventPropGetter}
        components={{
          toolbar: CustomToolbar,
          week: {
            header: CustomHeader,
          },
          event: (params: any) => (
            <CustomEventItem
              {...params}
              showDate={showDate}
              onClickEventItem={onClickEventItem}
            />
          ),
        }}
        onView={(newView) => setView(newView)}
      />
    </Stack>
  );
};

export default CalendarSchedule;
